import { createFileRoute } from "@tanstack/react-router";
import CareersPage from "@/pages/CareersPage";

const SITE_URL = "https://neurowellnesstms.com";

export const Route = createFileRoute("/careers")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Careers at Neuro Wellness TMS Centers of America | Coral Springs, FL",
        },
        {
          name: "description",
          content:
            "Join a mission-driven neuromodulation team in Coral Springs, FL. Open roles in psychiatry, TMS, therapy, patient care, and administration. Competitive pay.",
        },
        {
          property: "og:title",
          content:
            "Careers at Neuro Wellness TMS Centers of America | Coral Springs, FL",
        },
        {
          property: "og:description",
          content:
            "Join a mission-driven neuromodulation team in Coral Springs, FL. Open roles in psychiatry, TMS, therapy, patient care, and administration. Competitive pay.",
        },
        { property: "og:url", content: `${SITE_URL}/careers` },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
        {
          name: "twitter:title",
          content:
            "Careers at Neuro Wellness TMS Centers of America | Coral Springs, FL",
        },
        {
          name: "twitter:description",
          content:
            "Join a mission-driven neuromodulation team in Coral Springs, FL. Open roles in psychiatry, TMS, therapy, patient care, and administration. Competitive pay and benefits.",
        },
      ],
      links: [{ rel: "canonical", href: `${SITE_URL}/careers` }],
    };
  },
});

function RouteComponent() {
  return <CareersPage />;
}
